import { render, staticRenderFns } from "./IconFacebookMessenger.vue?vue&type=template&id=e59cabea&"
import script from "./IconFacebookMessenger.vue?vue&type=script&lang=js&"
export * from "./IconFacebookMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports